module.exports = __webpack_public_path__ + "img/mobilehome.11a9f7d.png";